(function(){
  "use strict";

  /* mobile menu toggle */
  var menuToggle = document.getElementById('MenuToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function(){
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.classList.toggle('is-open', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    mobileNav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        mobileNav.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
      });
    });
  }

  /* horizontal product scroller arrows */
  document.querySelectorAll('[data-product-scroll]').forEach(function(scroller){
    var wrapper = scroller.closest('.featured-section') || document;
    var left = wrapper.querySelector('[data-scroll-left]');
    var right = wrapper.querySelector('[data-scroll-right]');
    if (left) left.addEventListener('click', function(){ scroller.scrollBy({ left: -280, behavior: 'smooth' }); });
    if (right) right.addEventListener('click', function(){ scroller.scrollBy({ left: 280, behavior: 'smooth' }); });
  });

  /* product page: thumbnail swap */
  document.querySelectorAll('.product-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var mainImage = document.getElementById('ProductMainImage');
      var url = thumb.getAttribute('data-image-url');
      if (mainImage && url) {
  mainImage.removeAttribute('srcset');
  mainImage.removeAttribute('sizes');
  mainImage.setAttribute('src', url);

  var thumbnail = thumb.querySelector('img');
  if (thumbnail) {
    mainImage.alt = thumbnail.alt;
  }
}
    });
  });

  /* product page: variant picker keeps the correct variant id in sync */
  document.querySelectorAll('[id^="ProductVariantData-"]').forEach(function(script){
    var productId = script.id.replace('ProductVariantData-', '');
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }

    var form = document.querySelector('form[data-product-id="' + productId + '"]');
    if (!form) return;

    var selects = form.querySelectorAll('[data-option-index]');
    var hiddenId = form.querySelector('input[name="id"]');
    var submitBtn = form.querySelector('.product-add');

    function updateVariant(){
      var selected = Array.prototype.map.call(selects, function(s){ return s.value; });
      var match = variants.filter(function(v){
        return selected.every(function(val, i){ return v.options[i] === val; });
      })[0];
      if (match) {
        hiddenId.value = match.id;
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
        }
      }
    }
    selects.forEach(function(s){ s.addEventListener('change', updateVariant); });
  });

})();
